
import React from 'react';
import TranslatedText from '@/TranslatedText';
import { Flame, Tag } from 'lucide-react';

const HotDealsHeader: React.FC = () => {
  return (
    <div className="mb-4 text-center">
      <h2 className="text-xl sm:text-2xl font-semibold flex items-center justify-center gap-2 mb-1">
        <Flame className="text-red-500" size={24} />
        <TranslatedText text="Hot Deals" />
      </h2>
      <p className="text-sm text-gray-600 max-w-lg mx-auto">
        <TranslatedText text="Products with special discounts and coupon offers" />
        <Tag className="inline-block ml-1 text-blue-500" size={16} />
      </p>
    </div>
  );
};

export default HotDealsHeader;
